/* import __COLOCATED_TEMPLATE__ from './section.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface CollectionViewSettingsSectionSignature {
  Args: {
    onToggle: (section: string, isOpen: boolean) => void;
    section: string;
    settingsSection: unknown;
    title?: string;
    updated?: boolean;
  };
  Blocks: {
    default: [];
  };
}

const CollectionViewSettingsSectionComponent =
  templateOnlyComponent<CollectionViewSettingsSectionSignature>();

export default CollectionViewSettingsSectionComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'CollectionView::Settings::Section': typeof CollectionViewSettingsSectionComponent;
    'collection-view/settings/section': typeof CollectionViewSettingsSectionComponent;
  }
}
